<template>
  <div ref="visitPathRef" class="visit-path" :class="`visit-path-${blockuuid}`">
    <template v-for="(data, index1) in dataList" :key="index1">
      <div class="state-box" :class="[`stage-${index1}`]">
        <div :id="`svg-container-${index1}-${blockuuid}`" style="height: 36px"></div>

        <div
          :key="index1"
          class="item"
          :class="[
            index1 === 0 ? 'isfrist' : '',
            index1 === dataList.length - 1 && index1 !== 0 ? 'islast' : ''
          ]"
        >
          <div :id="`svg-item-title-${index1}-${blockuuid}`" class="item-title">
            <div class="index">{{ index1 + 1 }}</div>
            <div class="name">{{ data.name }}</div>
            <div class="subfix">{{ data.items.length }}个</div>
          </div>

          <div class="item-content">
            <template v-if="data.items?.length">
              <company-tag
                v-for="item in data.items"
                :key="item.id"
                :active-stage-id="activeStageId"
                class="table-line-item"
                :class="{ isActive: activeStageId === item.id }"
                is-review
                :item="item"
                @activeStageChange="handleActiveStageChange"
                @openDetail="handleOpenDetail"
              ></company-tag>
            </template>
            <div v-else class="item-content__empty">暂无会话数据</div>
          </div>

          <div class="item-bottom">
            <span class="desc">阶段时长</span>
            <span class="time">{{ data.time }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import CompanyTag from './company-tag.vue'

import xbb from '@xbb/xbb-utils'
import { ref, onMounted, nextTick } from 'vue'

defineOptions({
  name: 'VisitPath'
})

const props = defineProps({
  activeStageId: {
    type: Number,
    default: 1
  },
  behavingStageList: {
    type: Array,
    default: () => {
      return []
    }
  },
  isMobile: {
    type: Boolean,
    default: false
  }
})

const visitPathRef = ref(null)

const dataList = ref([])
const blockuuid = ref(xbb.guid())

const emits = defineEmits(['update:activeStageId', 'activeStageIdChange', 'activeStageChange'])

const handleOpenDetail = (item) => {
  if (props.activeStageId === item.id) {
    return
  }
  emits('update:activeStageId', item.id)
  emits('activeStageIdChange', item.id, true)
  handleActiveStageChange(item)
}

const handleActiveStageChange = (item) => {
  emits('activeStageChange', item)
}

onMounted(() => {
  dataList.value = xbb.deepClone(props.behavingStageList)
  nextTick(() => {
    const box = visitPathRef.value.querySelectorAll('.item')
    for (let i = 0; i < box.length; i++) {
      const itemStyle = window.getComputedStyle(box[i])
      let itemWidth =
        box[i].offsetWidth + parseInt(itemStyle.marginLeft) + parseInt(itemStyle.marginRight)
      if (i === 0) {
        itemWidth += 4
      } else if (i === box.length - 1) {
        itemWidth -= 8
      } else {
        itemWidth += 2
      }
      dataList.value[i].len = itemWidth
      const generateSvg = (_width, minWidth) => {
        const width = Math.max(_width, minWidth)
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
        svg.setAttribute('height', '36')
        svg.setAttribute('viewBox', `0 0 ${width} 36`)

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        if (i === 0) {
          path.setAttribute(
            'd',
            `M0,8C0,3.58172,3.58172,0,8,0L${width - 11},0L${width - 0.579},15.7812C${
              width + 0.321
            },17.1248,${width + 0.321},18.8752,${width - 0.579},20.2188L${
              width - 11
            },36L0,36L0,8ZM1,35L${width - 11.535},35L${width - 1.311},19.6641Q${width - 0.202},18,${
              width - 1.311
            },16.3359L${width - 11.535},1L8,1Q5.10051,1,3.05025,3.05025Q1,5.10051,1,8L1,35Z`
          )
        } else if (i === box.length - 1) {
          path.setAttribute(
            'd',
            `M12,18L0,36L${width},36L${width},8C${width},3.58172,${width - 3.418},0,${
              width - 8
            },0L0,0L12,18ZM1.86852,1L13.2019,18L1.86852,35L${width - 1},35L${width - 1},8Q${
              width - 1
            },5.10049,${width - 3.05},3.05025Q${width - 5.101},1,${width - 8},1L1.86852,1Z`
          )
        } else {
          path.setAttribute(
            'd',
            `M12,18L0,36L${width - 11},36L${width - 0.579},20.2188C${width + 0.321},18.8752,${
              width + 0.321
            },17.1248,${width - 0.579},15.7812L${
              width - 11
            },0L0,0L12,18ZM1.86852,1L12.8321,17.4453L13.2019,18L1.86852,35L${width - 11.535},35L${
              width - 1.311
            },19.6641Q${width - 0.202},18,${width - 1.311},16.3359L${width - 11.535},1L1.86852,1Z`
          )
        }
        path.setAttribute('fill-rule', 'evenodd')
        path.setAttribute('fill', '#E5E6EB')
        path.setAttribute('fill-opacity', '1')

        svg.appendChild(path)
        return svg
      }

      const updateSvgWidth = () => {
        const svgContainer = document.getElementById(`svg-container-${i}-${blockuuid.value}`)
        svgContainer.innerHTML = ''
        const svgItemTitle = document.getElementById(`svg-item-title-${i}-${blockuuid.value}`)
        const svgItemTitleWidth = svgItemTitle.offsetWidth + 20
        svgContainer.appendChild(generateSvg(itemWidth, svgItemTitleWidth))
      }
      updateSvgWidth()
      nextTick(() => {
        if (!props.isMobile) {
          visitPathRef.value.querySelector('.isActive').scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          })
        } else {
          const scrollContainer = document.querySelector(`.visit-path-${blockuuid.value}`)
          const activeElement = visitPathRef.value.querySelector('.isActive')
          // 计算目标元素相对于滚动容器的位置
          const containerRect = scrollContainer.getBoundingClientRect()
          const elementRect = activeElement.getBoundingClientRect()
          // 计算需要水平滚动的距离，使目标元素居中显示
          const scrollLeft =
            elementRect.left -
            containerRect.left +
            scrollContainer.scrollLeft -
            scrollContainer.clientWidth / 2 +
            elementRect.width / 2

          // 在容器上执行平滑水平滚动
          scrollContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          })
        }
      })
    }
  })
})
</script>

<style lang="scss" scoped>
.visit-path {
  position: relative;
  display: flex;
  width: 100%;
  padding-bottom: 12px;
  overflow-x: scroll;
  .state-box {
    display: flex;
    flex-direction: column;
    margin-left: -4px;
  }
  .stage-0 {
    margin-left: 0;
  }
}
.visit-path::-webkit-scrollbar {
  height: 6px;
  color: #c8c9cc;
}
.item {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: max-content;
  min-width: calc(100% - 11px);
  margin-right: 8px;
  background: #ffffff;
  .item-title {
    position: absolute;
    top: -36px;
    left: 16px;
    display: flex;
    align-items: center;
    width: max-content;
    padding: 8px;
    .index {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      margin-right: 8px;
      color: #ffffff;
      background: #c8c9cc;
      border-radius: 50%;
    }
    .name {
      margin-right: 8px;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: #323233;
    }
    .subfix {
      font-size: 12px;
      line-height: 20px;
      color: #969799;
    }
  }

  .item-bottom {
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    padding: 4px 8px;
    border: 1px solid #e5e6eb;
    .desc {
      margin-right: 12px;
      font-family: PingFang SC;
      font-size: 12px;
      line-height: 16px;
      color: #969799;
      white-space: nowrap;
    }
    .time {
      font-family: PingFang SC;
      font-size: 12px;
      line-height: 16px;
      color: #646566;
      white-space: nowrap;
    }
  }
  .item-content {
    // min-width: 180px;
    box-sizing: border-box;
    display: flex;
    flex: 1;
    padding: 8px 0 8px 8px;
    background: #f7f8fa;
    border-right: 1px solid #e5e6eb;
    border-left: 1px solid #e5e6eb;
    .table-line-item {
      margin-right: 8px;
      opacity: 0.5;
    }

    .isActive {
      opacity: 1;
    }
    .item-content__empty {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(100% - 8px);
      height: 52px;
      font-family: PingFang SC;
      font-size: 12px;
      line-height: 16px;
      color: #969799;
    }
  }
}
.isfrist {
  .item-title {
    left: 4px;
    border-radius: 8px 0px 0px 0px;
  }
  .item-bottom {
    border-radius: 0px 0px 0px 8px;
  }
}
.islast {
  min-width: 100%;
  .item-title {
    border-radius: 0px 8px 0px 0px;
  }
  .item-bottom {
    border-radius: 0px 0px 8px 0px;
  }
}
</style>
